import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import SquareCheckOff from '../../icons/SquareCheckOff';
import SquareCheckOn from '../../icons/SquareCheckOn';
import Button from '../Button';


const CheckBox = ({ label, style, labelStyle, checked, onPress, className}, ref) => {
    const [isChecked, setChecked] = useState(false)
    const handleCheck = (value)=>{
        onPress && onPress()
       // setChecked(value)
    }
    
    useImperativeHandle(ref, () => ({
        handleCheck: handleCheck
    }))

    useEffect(()=>{
        //if(checked) setChecked(checked)
    }, [checked])
    return (
        <Button
            style={{...styles.row, ...style}}
            onClick={()=> handleCheck(!checked)}
            className={className}
        >
            {!checked ? <SquareCheckOff /> :  <SquareCheckOn />}
            <label style={{...styles.checkBoxLabel, ...labelStyle}} className='body_15_medium'>{label}</label>
        </Button>
    )
}

const styles = {
    row: {
        flexDirection: 'row',
        display: 'flex',
        alignItems: 'flex-start',
        width: '100%'
    },
    checkBoxLabel: {
        fontSize: 16,
        letterSpacing: 0,
        color: "#fff",
        marginLeft: 6,
        flex: 1,
        textAlign: 'left'
    },
}
export default forwardRef(CheckBox);